import AsyncSelectField from "@components/fields/react-select/async-select";
import {
    Badge
} from "reactstrap";
import Charts from "@components/charts";
import { ComponentSpinner } from "@components/spinner";
import DateRangePicker from "@components/fields/date-picker/range-picker";
import Flex from "@components/ui-components/flex";
import HeatMapChart from "@components/charts/heaptmap";
import { LAST_6_MONTHS_DATE } from "@src/utility/constants";
import { Link, useParams } from "react-router-dom";
import size from "lodash/size";
import useDateHandler from "@src/utility/hooks/use-date-handler";
import useFilters from "@src/views/common/hooks/use-filter";
import { useTranslation } from "react-i18next";
import useUsage from "./use-usage";

const Usage = (props) => {
    const {
        segments,
        loading,
        onSubmit,
        methods: filterMethods,
        activeUserData,
        handleEventSelect,
        usageData,
        heatMapData
    } = useUsage(props);
    const { platformId } = useParams();
    const { control, handleDateChange } = useDateHandler({
        onSubmit,
        defaultHandling: true,
        defaultValues  : LAST_6_MONTHS_DATE
    });
    const { t } = useTranslation();

    const { control: filterControl, formState: { errors: filterErrors } } = filterMethods;

    const { loadAsyncOptions } = useFilters();

    return (
        <div className="px-1">
            <Flex className="w-100" justify="between" align="center">
                <h1>{t("Usage")}</h1>

                <Flex className="w-50" justify="end" align="center">
                    <AsyncSelectField
                        loadOptions={(value, callback) => {
                            loadAsyncOptions({
                                value,
                                callback,
                                customURL: `events/${platformId}/filter`
                            });
                        }}
                        defaultOptions
                        id="event"
                        isClearable
                        customOnChange={handleEventSelect}
                        name="event"
                        className="w-50"
                        placeholder="Select Event"
                        control={filterControl}
                        errors={filterErrors} />
                    <DateRangePicker
                        id="date"
                        name="date"
                        btnClass="me-1"
                        control={control}
                        customOnChange={handleDateChange} />
                </Flex>
            </Flex>
            <hr />

            <HeatMapChart
                loading={loading}
                cardHeader={{ title: "Event Frequency" }}
                data={heatMapData} />

            <Charts
                loading={loading}
                title="Active Users"
                cardHeader={{ title: "Active Users" }}
                type="line"
                series={activeUserData.series}
                categories={activeUserData.categories} />

            <Charts
                loading={loading}
                title="Events Over Time"
                cardHeader={{ title: "Events Over Time" }}
                type="line"
                series={usageData.series}
                categories={usageData.categories} />

            <h2>{t("Segments")}</h2>
            <hr />
            <div className="w-100">
                {loading ? (
                    <ComponentSpinner />
                ) : size(segments) ? (
                    <div className="list-group">
                        {segments.map(segment => (
                            <Link
                                to={`/segments?id=${segment._id}`}
                                key={segment._id}
                                className="list-group-item list-group-item-action d-flex justify-content-between align-items-center hover-bg-primary cursor-pointer">
                                <h4 className="mb-0 text-primary">{segment.name}</h4>
                                <Badge pill color="primary">
                                    {segment.clientCount} {t("Clients")}
                                </Badge>
                            </Link>
                        ))}
                    </div>
                ) : null}
            </div>
        </div>
    );
};
export default Usage;